import React from 'react';
import { BrowserRouter as Router, useLocation, Redirect } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import SecondaryNavBar from './components/navigation/SecondaryNavBar';
import Header from './components/navigation/Header';
import { AuthProviderWithHistory, useAuth } from './contexts/AuthContext';
import { EntityProvider } from './contexts/EntityContext';
import { YearProvider } from './contexts/YearContext';
import { AreaProvider } from './contexts/AreaContext';
import AppRoutes from './routes';

const AppContent: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Define public routes that should not show navigation bars
  const publicRoutes = ['/login', '/esqueci-senha', '/recuperar-senha'];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  if (!isAuthenticated && !publicRoutes.includes(location.pathname)) {
    return <Redirect to={{ pathname: "/login", state: { from: location } }} />;
  }

  // Only wrap with EntityProvider if authenticated
  const content = (
    <div className="app-container">
      {isAuthenticated && !isPublicRoute && <Header />}
      <div className="main-content">
        {isAuthenticated && !isPublicRoute && <SecondaryNavBar />}
        <div className="content-wrapper">
          <AppRoutes />
        </div>
      </div>
    </div>
  );

  return isAuthenticated ? (
    <EntityProvider>
      <AreaProvider>
        <YearProvider>
          {content}
        </YearProvider>
      </AreaProvider>
    </EntityProvider>
  ) : content;
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProviderWithHistory>
        <AppContent />
      </AuthProviderWithHistory>
    </Router>
  );
};

export default App;
